import qs from 'qs'
import type { ClientOptions } from '../types'

// Based on the @factry/client/client.ts but without all the auth code.

export const settings = {
  basePath: '',
}

class HttpError {
  code: number
  text: string
  body: unknown

  constructor (response: Response) {
    this.code = response.status
    this.text = response.statusText
  }

  async setBody (response: Response): Promise<void> {
    const json = await response.json() as unknown
    this.body = json
  }
}

export default (url: string, options: ClientOptions = {}): Promise<any> => {
  if (!settings.basePath) throw Error('Basepath for the client was not set')

  const paramUrl = options.params
    ? `${url}?${qs.stringify(options.params)}`
    : url

  return window.fetch(`${settings.basePath}${paramUrl}`, {
    ...options,
    headers: {
      ...(options.json ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
    ...(options.json ? { body: JSON.stringify(options.json) } : {}),
  })
    .then(async res => {
      if (!res.ok) {
        const err = new HttpError(res)
        await err.setBody(res)
        return Promise.reject(err)
      }

      if (options.method === 'HEAD') return res.headers

      const contentType = res.headers.get('Content-Type')
      if (contentType?.includes('application/json')) return res.json()
      return res
    })
}
